type JSONCSVMapping = {
  id: Maybe<number>;
  name: string;
  is_active: boolean;
  field_mappings: JSONFieldMapping[];
};

type CSVMapping = {
  id: Maybe<number>;
  name: string;
  isActive: boolean;
  fieldMappings: FieldMapping[];
};

type JSONFieldMapping = {
  col_name: string;
  col_idx: number;
  field: JSONField;
};

type FieldMapping = {
  colName: string;
  colIdx: number;
  field: Field;
};

type JSONField = {
  is_required: boolean;
  name: string;
  id: number;
};

type Field = {
  isRequired: boolean;
  name: string;
  id: number;
};

function fieldFromJSON(jsonField: JSONField): Field {
  return {
    isRequired: jsonField.is_required,
    name: jsonField.name,
    id: jsonField.id,
  };
}

function fieldToJSON(field: Field): JSONField {
  return {
    is_required: field.isRequired,
    name: field.name,
    id: field.id,
  };
}

function fieldMappingFromJSON(jsonFieldMapping: JSONFieldMapping): FieldMapping {
  return {
    colName: jsonFieldMapping.col_name,
    colIdx: jsonFieldMapping.col_idx,
    field: fieldFromJSON(jsonFieldMapping.field),
  };
}

function fieldMappingToJSON(fieldMapping: FieldMapping): JSONFieldMapping {
  return {
    col_name: fieldMapping.colName,
    col_idx: fieldMapping.colIdx,
    field: fieldToJSON(fieldMapping.field),
  };
}

function fromJSON(jsonCSV: JSONCSVMapping): CSVMapping {
  return {
    id: jsonCSV.id,
    name: jsonCSV.name,
    isActive: jsonCSV.is_active,
    fieldMappings: jsonCSV.field_mappings.map(fieldMappingFromJSON),
  };
}

function toJSON(csvMapping: CSVMapping): JSONCSVMapping {
  return {
    id: csvMapping.id,
    name: csvMapping.name,
    is_active: csvMapping.isActive,
    field_mappings: csvMapping.fieldMappings.map(fieldMappingToJSON),
  };
}

export default CSVMapping;

export { fromJSON, toJSON, fieldMappingToJSON, JSONCSVMapping, Field, FieldMapping };
